import * as Rollbar from "rollbar";

export const getRollbar = () => {
    // eslint-disable-next-line prefer-const
    let useRollbar = "true"; // Replaced by CI
    if (useRollbar == "true") {
        return new Rollbar({
            accessToken: "11630978feb945deaba12bd200342a6a", // Replaced by CI
            captureUncaught: true,
            autoInstrument: true,
            payload: {
                environment: "test-linux", // Replaced by CI
                client: {
                    javascript: {
                        source_map_enabled: true,
                        code_version: "a726c3328b7d51189fff1db421bf3ed91c1ac8ee", // Replaced by CI
                        guess_uncaught_frames: true
                    }
                }
            }
        });
    }

    return null;
};